export enum BFIExperienceActionType {
    ViewExperience = 0,
    ViewLoan = 1,
}
